import React from 'react';
import { useSelector } from 'react-redux';

import { getHome } from 'core/selectors';

import { BannersCarousel } from './BannersCarousel';

export const Container = () => {
  const { banners } = useSelector(getHome);

  if (!banners.length) {
    return null;
  }

  return <BannersCarousel items={banners} />;
};
